module.exports = __webpack_public_path__ + "img/IMG_2024_L_Wood_MockedUp.a7092ded.jpg";